import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import updateLocale from 'dayjs/plugin/updateLocale'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import localeData from 'dayjs/plugin/localeData'
import customParseFormat from 'dayjs/plugin/customParseFormat'

// Настраиваем dayjs
dayjs.locale('ru')
dayjs.extend(updateLocale)
dayjs.extend(weekday)
dayjs.extend(weekOfYear)
dayjs.extend(localeData)
dayjs.extend(customParseFormat)

// Устанавливаем понедельник как первый день недели
dayjs.updateLocale('ru', {
  weekStart: 1,
})

export default dayjs
